import { createSlice } from '@reduxjs/toolkit';
import { ErrorInfo, FormError } from 'modules/utils/error/Errors';
import { registerLegalEntity, registerPrivateIndividual } from './thunks';

export interface RegisterUserState {
  error?: string;
  loading?: boolean;
  success?: boolean | undefined;
  validationErrors?: ErrorInfo[] | undefined;
}

const initialState: RegisterUserState = {
  error: undefined,
  loading: true,
  success: undefined,
  validationErrors: undefined,
};

export const registerUserSlice = createSlice({
  name: 'registerUser',
  initialState,
  reducers: {
    resetState(state) {
      state.loading = initialState.loading;
      state.error = initialState.error;
      state.success = initialState.success;
    },
    resetFormValidations(state) {
      state.validationErrors = initialState.validationErrors;
    },
  },
  extraReducers: (builder) => {
    // private individual
    builder.addCase(registerPrivateIndividual.pending, (state) => {
      state.loading = initialState.loading;
      state.error = initialState.error;
      state.success = initialState.success;
      state.validationErrors = initialState.validationErrors;
    });
    builder.addCase(registerPrivateIndividual.fulfilled, (state, action) => {
      state.loading = false;
      state.success = action.payload;
    });
    builder.addCase(registerPrivateIndividual.rejected, (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload
        ? (action.payload as Error)?.message
        : action.error?.message;
      state.validationErrors = action.payload
        ? (action.payload as FormError).fieldErrors
        : undefined;
    });

    // legal entity
    builder.addCase(registerLegalEntity.pending, (state) => {
      state.loading = initialState.loading;
      state.error = initialState.error;
      state.success = initialState.success;
      state.validationErrors = initialState.validationErrors;
    });
    builder.addCase(registerLegalEntity.fulfilled, (state, action) => {
      state.loading = false;
      state.success = action.payload;
    });
    builder.addCase(registerLegalEntity.rejected, (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload
        ? (action.payload as Error)?.message
        : action.error?.message;
      state.validationErrors = action.payload
        ? (action.payload as FormError).fieldErrors
        : undefined;
    });
  },
});

export const { resetState, resetFormValidations } = registerUserSlice.actions;

export default registerUserSlice.reducer;
